import { useState } from 'react';
import { BillingApi } from '#shared/components/AccountAndBilling/types';

// The invoice-PDF op is host-supplied (account vs partner endpoint) — the (c) interface. Both hosts
// return the PDF under `InvoicePDF`, so no host-side normalization is needed here.
export default function useFetchInvoicePdf(fetchInvoicePdfOp: BillingApi['fetchInvoicePdf']) {
  const [fetching, setFetching] = useState(false);

  const fetchInvoicePdf: BillingApi['fetchInvoicePdf'] = async (params) => {
    try {
      setFetching(true);
      const res = await fetchInvoicePdfOp(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  };

  return { fetching, fetchInvoicePdf };
}
